<template>
	<el-drawer :modal="false"  name="drawer-create-user" :visible.sync="show_drawer" class="drawer-create-user" id="drawer_update_user" @close="closeDrawer"
		size="40%">
		<div slot="title" class="d-flex justify-content-between align-items-center">
			<span>Update User</span>
			<span>
				<b-button variant="default" class="btn-header" @click="switchTab('configurations')">Configurations</b-button>
			</span>
		</div>
		<!-- <b-button variant="default" class="btn-header btn-block" @click="switchTab('configurations')">Configurations</b-button> -->
		<b-container>
			<form @submit.prevent="submitUpdate">
				<b-row align-v="center" class="py-3">
					<b-col v-if="double_message" md="12">
						<div class="alert alert-warning">{{ double_message }}</div>
					</b-col>
					<b-col md="12">
						<b-form-group label="Name" class="mb-3">
							<b-form-input v-model="formParams.name" type="text" required></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group class="mb-3" label="Email">
							<b-form-input v-model="formParams.email" type="email" required readonly></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group class="mb-3" label="Contact No">
							<b-form-input v-model="formParams.contact_number" type="number"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group class="mb-3" label="IC Number">
							<b-form-input v-model="formParams.ic_number" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col cols="6" md="6"></b-col>
					<b-col cols="6" md="6">
						<b-form-group class="mb-3" label="Bank Name">
							<b-form-input v-model="formParams.bank_name" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col cols="6" md="6">
						<b-form-group class="mb-3" label="Bank Account">
							<b-form-input v-model="formParams.bank_account" type="number"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-3" label="Address">
							<b-form-input v-model="formParams.address" type="text"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-2" label="Role">
							<el-select v-model="formParams.role_id" filterable placeholder="Select Role">
								<el-option v-for="role in availableRoles" :key="role.role_id" :label="role.role_name"
									:value="role.role_id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col md="12" v-if="_gAuth.isAppSas()">
						<b-form-group class="mb-4">
							<el-checkbox v-model="formParams.setting_json.is_external_staff">
								This user is external staff</el-checkbox>
						</b-form-group>
					</b-col>
					<!-- karen ask to hide -->
					<b-col md="12">
						<span class="text-red">** This person is able to see all listing data on this user</span>
						<b-form-group class="mb-4" label="Team Manager">
							<el-select v-model="formParams.mlv_upl_id" filterable placeholder="Select Direct Upline">
								<el-option v-for="upline in userUplineList" :key="upline.id"
									:label="upline.role.role_type + ' - ' + upline.user.name" :value="upline.id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-4" label="Team Assistant Manager (optional)">
							<el-select v-model="formParams.am_user_id" filterable placeholder="Select Assistant Manager">
								<el-option v-for="upline in userUplineList" :key="upline.id"
									:label="upline.role.role_type + ' - ' + upline.user.name" :value="upline.id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-4" label="Referral Type">
							<el-select v-model="formParams.referral_type" filterable placeholder="Select Referral Type">
								<el-option v-for="option in referralTypeOptions" :key="option.value" :value="option.value"
									:label="option.label">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-row>
							<b-col cols="12" md="6">
								<b-form-group class="mt-4" label="Is Assistant Manager">
									<el-radio-group v-model="formParams.is_assistant_manager">
										<el-radio label="HUB" value="HUB" />
										<el-radio label="TEAM" value="TEAM" />
										<el-radio label="NOT" value="NULL" />
									</el-radio-group>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="6">
								<b-form-group label="Hub AM Comms Percent(%)" v-if="formParams.is_assistant_manager == 'HUB'">
									<b-form-input v-model="formParams.setting_json.comms_setting.hub_am_comms_percentage" step="0.01" type="number"></b-form-input>
								</b-form-group>
								<b-form-group label="Team AM Comms Percent(%)" v-else-if="formParams.is_assistant_manager == 'TEAM'">
									<b-form-input v-model="formParams.setting_json.comms_setting.team_am_comms_percentage" step="0.01" type="number"></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
					</b-col>
					
					<b-col cols="6" md="6" v-if="(_gAuth.isAppSas() || _gHlp.checkAccess(['stg_channel_platform']))">
							<b-form-group label="Platform">
									<el-select v-model="formParams.platform_id" placeholder="Select Platform">
											<el-option :label="'-'" :value="null">-</el-option>
											<el-option
											v-for="item in listPlatforms"
											:key="item.platform_id"
											:label="item.name"
											:value="item.platform_id">
											</el-option>
									</el-select>
							</b-form-group>
					</b-col>
					<b-col cols="6" md="6" v-if="(_gAuth.isAppSas() || _gHlp.checkAccess(['stg_channel_platform']) )">
							<b-form-group label="Channel" >
									<el-select v-model="formParams.channel_id" placeholder="Select Channel">
											<el-option :label="'-'" :value="null">-</el-option>
											<el-option
											v-for="item in listChanels"
											:key="item.channel_id"
											:label="item.name"
											:value="item.channel_id">
											</el-option>
									</el-select>
							</b-form-group>
					</b-col>

					<b-col md="12" v-if="isCorporateAllowLeadReassign">
						<b-form-group class="mb-2">
							<el-checkbox v-model="formParams.is_have_recyle_lead">
								Allow receive leads reshuffle</el-checkbox>
						</b-form-group>
					</b-col>

					<b-col md="12">
						<b-form-group class="mb-4">
							<el-checkbox v-model="formParams.is_use_corp_subscription">
								Allow use corporate subscription and credit balance</el-checkbox>
						</b-form-group>
					</b-col>

					<b-col md="12" class="m-0" v-if="formParams.is_use_corp_subscription == 1">
						<strong>Credit report balance limit usage [ 0 = unlimited ]</strong>
					</b-col>
					<b-col md="4" v-if="formParams.is_use_corp_subscription == 1">
						<b-form-group class="mb-3" label="Daily Limit">
							<b-form-input v-model="formParams.pull_report_limit_json.daily" min="0" type="number"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="4" v-if="formParams.is_use_corp_subscription == 1">
						<b-form-group class="mb-3" label="Weekly Limit">
							<b-form-input v-model="formParams.pull_report_limit_json.weekly" min="0" type="number"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="4" v-if="formParams.is_use_corp_subscription == 1">
						<b-form-group class="mb-3" label="Monthly Limit">
							<b-form-input v-model="formParams.pull_report_limit_json.monthly" min="0" type="number"></b-form-input>
						</b-form-group>
					</b-col>

				<el-drawer :modal="false"  name="drawer-configurations" :visible.sync="show_configurations_drawer" class="drawer-create-user" size="40%">
					<div slot="title" class="d-flex justify-content-between align-items-center">
						<span>Configurations</span>
						<span>
							<b-button variant="default" class="btn-header" @click="addNewKPI()">Add New</b-button>
						</span>
					</div>
					<b-row >
						<h4 class="mx-4"><strong>KPI Settings</strong></h4>
						<b-col md="12">
							<b-form-group class="mb-4 ml-2">
							    <b-row>
									<b-col md="3" v-if="formParams.setting_json.kpi_setting">
							<b-form-group class="mb-3" label="Revenue Target">
								<b-form-input v-model="formParams.setting_json.kpi_setting.revenue.target" type="number"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col md="3" v-if="formParams.setting_json.kpi_setting">
							<b-form-group class="mb-3" label="Revenue Duration">
								<el-select v-model="formParams.setting_json.kpi_setting.revenue.duration" placeholder="Select Duration">
									<el-option label="MONTHLY" value="MONTHLY"></el-option>
									<el-option label="QUARTERLY" value="QUARTERLY"></el-option>
									<el-option label="YEARLY" value="YEARLY"></el-option>
								</el-select>
							</b-form-group>
						</b-col>
						<b-col md="3" v-if="formParams.setting_json.kpi_setting">
							<b-form-group class="mb-3" label="Revenue From">
								<b-form-input v-model="formParams.setting_json.kpi_setting.revenue.revenueFrom" type="date"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col md="3" v-if="formParams.setting_json.kpi_setting">
							<b-form-group class="mb-3" label="Revenue To">
								<b-form-input v-model="formParams.setting_json.kpi_setting.revenue.revenueTo" type="date"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-4 ml-2">
							<b-row>
								<b-col md="3" v-if="formParams.setting_json.kpi_setting">
									<b-form-group class="mb-3" label="Case Target">
										<b-form-input v-model="formParams.setting_json.kpi_setting.case.target" type="number"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col md="3" v-if="formParams.setting_json.kpi_setting">
									<b-form-group class="mb-3" label="Case Duration">
										<el-select v-model="formParams.setting_json.kpi_setting.case.duration" placeholder="Select Duration">
											<el-option label="MONTHLY" value="MONTHLY"></el-option>
											<el-option label="QUARTERLY" value="QUARTERLY"></el-option>
											<el-option label="YEARLY" value="YEARLY"></el-option>
													</el-select>
									</b-form-group>
								</b-col>
								<b-col md="3" v-if="formParams.setting_json.kpi_setting">
									<b-form-group class="mb-3" label="Case From">
										<b-form-input v-model="formParams.setting_json.kpi_setting.case.caseFrom" type="date"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col md="3" v-if="formParams.setting_json.kpi_setting">
									<b-form-group class="mb-3" label="Case To">
										<b-form-input v-model="formParams.setting_json.kpi_setting.case.caseTo" type="date"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
						</b-form-group>
					</b-col>
				
					<b-col md="12">
						<b-form-group class="mb-4 ml-2">
							<b-row>
								<b-col md="4" v-if="formParams.setting_json.kpi_setting">
									<b-form-group class="mb-3" label="Revenue Point Target">
										<b-form-input v-model="formParams.setting_json.kpi_setting.revenue_point.target" type="number"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col md="4" v-if="formParams.setting_json.kpi_setting">
									<b-form-group class="mb-3" label="Revenue Point Duration">
										<el-select v-model="formParams.setting_json.kpi_setting.revenue_point.duration" placeholder="Select Duration">
											<el-option label="MONTHLY" value="MONTHLY"></el-option>
											<el-option label="QUARTERLY" value="QUARTERLY"></el-option>
											<el-option label="YEARLY" value="YEARLY"></el-option>
											<!-- Add more options as needed -->
										</el-select>
									</b-form-group>
								</b-col>
							</b-row>
						</b-form-group>
					</b-col>
				</b-row>
				<el-table class="mx-2" :data="kpiSettingArray" stripe style="width: 100%">
					<el-table-column prop="type" label="Type"></el-table-column>
					<el-table-column label="Target & Duration" width="200">
						<template slot-scope="scope">
							<div>{{ scope.row.target }} ({{ scope.row.duration }})</div>
						</template>
					</el-table-column>
					<el-table-column label="From/To" >
						<template slot-scope="scope">
							<div v-if="scope.row.type === 'REVENUE'">{{ scope.row.revenueFrom }} - {{ scope.row.revenueTo }}</div>
							<div v-else-if="scope.row.type === 'CASE'">{{ scope.row.caseFrom }} - {{ scope.row.caseTo }}</div>
						</template>
					</el-table-column>
					<el-table-column label="Action" >
						<template slot-scope="scope">
							<!-- Use a button or icon for deletion -->
							<el-button type="text" @click="removeRow(scope.$index)">Delete</el-button>
						</template>
					</el-table-column>
				</el-table>

				<b-row align-v="center" class="py-3 d-flex justify-content-between m-2">	
					<b-col cols="6">
						<b-button variant="primary" class="btn-header btn-block" type="submit">Update</b-button>
					</b-col>
				</b-row>
			</el-drawer>
					<b-col md="12">
						<b-form-group class="mb-4" label="Status">
							<el-select v-model="formParams.status" filterable placeholder="Select">
								<el-option v-for="(user_status, index) in user_statuses" :key="index" :label="user_status" :value="index">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<h3 class="mx-3"><strong>Commission Settings</strong></h3>
					<b-col md="12" v-if="_gAuth.isAppSas()">
						<b-row>
							<b-col cols="12">
								<b-form-group label="Hub Position">
									<el-select v-model="formParams.hub_type" placeholder="Select Hub Position" :disabled="is_req_transfer_member">
										<el-option label="---Select---" :value="null"></el-option>
										<el-option label="Hub Manager" value="hub_manager"></el-option>
										<el-option label="Team Manager" value="team_manager"></el-option>
										<el-option label="Member" value="member"></el-option>
									</el-select>
								</b-form-group>
							</b-col>

							<b-col cols="12" class="mb-3"  v-if="!_gHlp.isEmpty(formParams.hub_type) && formParams.hub_type != 'member'">
								<b-row v-if="formParams.hub && formParams.hub_type == 'hub_manager'">
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Name">
											{{formParams.hub.group_name}}
									</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Manager">
											{{formParams.hub.group_owner.name}}
										</b-form-group>
									</b-col>
								</b-row>
								<b-row v-else-if="formParams.hub && formParams.hub_type == 'team_manager'">
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Name">
											{{formParams.hub.team_group.group_name}}
										</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Manager">
											{{formParams.hub.team_group.group_owner.name}}
										</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Team Name">
											{{ formParams.hub.team_name }}
										</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Team Manager">
											{{ formParams.hub.team_owner.name }}
										</b-form-group>
									</b-col>
								</b-row>
								<b-row v-else>
									<b-col md="6" cols="12" class="mb-4">
										<i>No Hub / Team selected for this user</i>
									</b-col>
								</b-row>
								<div class="alert alert-warning">
									This Agent hub position is selected as {{_gHlp.getUnSlug(formParams.hub_type)}}, for update please change from commission site.
									<a class="text-primary" href="javascript:void(0)" @click="goToSasCommission()"> Go to commission hub </a>
								</div>	
							</b-col>

							<b-col cols="12"  v-if="formParams.hub_type == 'member'">
								<b-form-group label="Team Group (Hub)">
									<el-select v-model="formParams.team_group_id" filterable placeholder="Select Hub"  :disabled="is_req_transfer_member">
										<el-option :key="null" :label="'---Select---'" :value="null"></el-option>
										<el-option v-for="(option,index) in teamGroupList"
										:key="index"
										:label="option.group_name"
										:value="option.team_group_id">
										</el-option>
									</el-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" v-if="formParams.hub_type == 'member'">
								<b-form-group label="Team">
									<el-select v-model="formParams.team_id" filterable placeholder="Select Team"  :disabled="is_req_transfer_member">
										<el-option :key="null" :label="'---Select---'" :value="null"></el-option>
										<el-option v-for="(option,index) in availableTeamList"
											:key="index"
											:label="option.team_name"
											:value="option.team_id">
										</el-option>
									</el-select>
								</b-form-group>
								<div class="alert alert-warning" v-if="is_req_transfer_member">
									This Agent waiting approval transfer member to another team.
									<a class="text-primary" href="javascript:void(0)" @click="goToSasCommission()"> Go to commission hub </a>
								</div>	
							</b-col>
						</b-row>
					</b-col>
					<b-col md="12" v-if="!_gAuth.isAppSas()">
						<b-row>
							<b-col cols="12" md="6">
								<b-form-group label="Hub Manager">
									<el-select v-model="formParams.group_owner_id" filterable placeholder="Select Hub Manager">
										<el-option :key="null" :label="'---Select---'" :value="null"></el-option>
										<el-option v-for="option in hubManagerUserList"
											:key="option.id"
											:label="option.name"
											:value="option.id">
										</el-option>
									</el-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="6">
								<b-form-group label="Team Manager">
									<el-select v-model="formParams.team_owner_id" filterable placeholder="Select Hub Manager">
										<el-option :key="null" :label="'---Select---'" :value="null"></el-option>
										<el-option v-for="option in teamManagerUserList"
											:key="option.id"
											:label="option.name"
											:value="option.id">
										</el-option>
									</el-select>
								</b-form-group>
							</b-col>
							<template v-if="formParams.hub == null">
								<b-col cols="12">
									<b>No Hub for this user</b>
								</b-col>
							</template>
							<template v-else>
								<template v-if="formParams.hub_type == 'hub_manager'">
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Name">
											{{formParams.hub.group_name}}
									</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Manager">
											{{formParams.hub.group_owner.name}}
										</b-form-group>
									</b-col>
								</template>
								<template v-else-if="formParams.hub_type == 'team_manager' || formParams.hub_type == 'member'">
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Name">
											{{formParams.hub.team_group.group_name}}
									</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Hub Manager">
											{{formParams.hub.team_group.group_owner.name}}
										</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Team Name">
											{{ formParams.hub.team_name }}
										</b-form-group>
									</b-col>
									<b-col md="6" cols="12">
										<b-form-group class="mb-4" label="Team Manager">
											{{ formParams.hub.team_owner.name }}
										</b-form-group>
									</b-col>
								</template>
							</template>
						</b-row>
					</b-col>

					<b-col md="12" cols="12">
						<b-form-group class="mb-4" label="Recruit By">
							<el-select v-model="formParams.referral_by" filterable placeholder="Select">
								<el-option v-for="user in recruitUserList" :key="user.id" :label="user.name" :value="user.id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col cols="6">
						<b-form-group class="mb-4" label="Created On">
							<p>{{ formParams.created_at }}</p>
						</b-form-group>
					</b-col>
					<b-col cols="6" v-if="_gAuth.isAppSas() && isUserResign">
						<b-form-group class="mb-4" label="Resign On">
							<p>{{ formParams.resign_at }}</p>
						</b-form-group>
					</b-col>
					<b-col cols="12" v-if="_gAuth.isAppSas() && !isUserResign">
						<b-form-group class="mb-3" label="Resign On" v-if="!is_req_resign_member">
							<b-input-group>
								<b-form-input v-model="formParams.resign_at" type="date"></b-form-input>
								<b-input-group-append>
									<b-button variant="danger" @click="submitReqResign(_gHlp.formatMomentDate(_gHlp.getCurrentDateTime(), 'YYYY-MM-DD'))">Submit Resign Approval</b-button>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
						<div class="alert alert-warning" v-if="is_req_resign_member">
									This Agent waiting resign approval.
							<a class="text-primary" href="javascript:void(0)" @click="goToSasCommission()"> Go to commission hub </a>
						</div>	
					</b-col>
				</b-row>
				<b-row align-v="center" class="py-3 d-flex justify-content-between">
					<b-col cols="6">
						<b-button variant="default" class="btn-header btn-block" @click="closeDrawer()">Cancel</b-button>
					</b-col>
					<b-col cols="6">
						<b-button variant="primary" class="btn-header btn-block" type="submit">Update</b-button>
					</b-col>
				</b-row>
			</form>
		</b-container>

	</el-drawer>
</template>
<script>
import {Table, TableColumn, Drawer, Select, Option, Input, Button, Checkbox, RadioGroup, Radio, RadioButton } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useCommissionStore } from '@/stores/commissionStore'
import { mapActions, mapState } from 'pinia'
import { sasv3CommissionDomain} from '@/assets/js/config.js'
import {
	axios,
	services,
	getHeader,
	debounce,
	swal
} from '@/assets/js/httpImports.js'
import _ from 'lodash'
export default {
	props: ['listChanels','listPlatforms'],
	components: {
		ValidationObserver,
		ValidationProvider,
		[Table.name]: Table,
        [TableColumn.name]: TableColumn,
		[Input.name]: Input,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox,
		[Drawer.name]: Drawer,
		[RadioGroup.name]: RadioGroup,
		[Radio.name]: Radio,
		[RadioButton.name]: RadioButton,
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useConfigStore, ['app_code']),
		...mapState(useAccessControlStore, ['userList', 'roleList', 'userUplineList']),
		...mapState(useCommissionStore, ['hubManagerUserList', 'teamManagerUserList', 'teamList', 'teamGroupList']),
		totalUsers() {
			return this.userList.length;
		},
		isUserResign() {
			return !_gHlp.isEmpty(_gHlp.getValue(this.editData,'current_user_application.setting_json.comms_setting.resign_at',null))
		},
		isExceedUser() {
			return this.totalUsers > this.auth_user.subscription.privileges.scpk_limit_user
		},
		isCorporateAllowLeadReassign() {
			let corpSetting = _gAuth.activeCorpSettings();
			return !_gHlp.isEmpty(corpSetting) ? corpSetting.is_lead_auto_assign : false
		},
		availableRoles() {
			if (this.roleList.length > 0) {
				// if (!_gAuth.isAppSas()) {
				// 	if (this.auth_user.subscription.privileges.scpk_name.toLowerCase() === 'team') {
				// 		return this.roleList.filter((role) => role.role_type !== 'admin' && role.role_type !== 'corporate')
				// 	} else {
				// 		return this.roleList.filter((role) => role.role_name !== 'Admin')
				// 	}
				// } else {
				// 	return this.roleList;
				// }
				return this.roleList;
			}
			return [];
		},
		recruitUserList() {
			return this.userList.filter((item) => item.status == 1)
		},
		availableTeamList(){
			if(_gHlp.isEmpty(this.teamList)) return []
			return this.teamList.filter(item => item.team_group_id == this.formParams.team_group_id)
		}
	},
	async created() {
		await this.getCommissionTeamList()
		await this.getCommissionTeamGroupList()
  },
	mounted() {
	},
	data() {
		return {
			editData:{},
			kpiSettingArray:[],
			show_drawer: false,
			show_configurations_drawer: false, 
			is_req_transfer_member:false,
			is_req_resign_member:false,
			formParams: {
				name: '',
				email: '',
				contact_number: '',
				role_id: '',
				mlv_upl_id: '',
				am_user_id: '',
				report_to_id: '',
				channel_id: '',
				platform_id: '',
				referral_by: '',
				created_at: '',
				pull_report_limit_json: {
					daily: 0,
					weekly: 0,
					monthly: 0
				},
				is_use_corp_subscription: true,
				is_have_recyle_lead: false,
				is_assistant_manager: null,
				status: '',
				referral_type: '',
				resign_at:'',
				hub_type:'',
				team_group_id:'',
				team_id:'',
				group_owner_id: '',
				team_owner_id: '',
				setting_json:
				{
					kpi_setting: {
						revenue: {
							target: '',
							duration: '',
						revenueFrom:'',
						revenueTo:'',
						},
						case: {
							target: '',
							duration: '',
						caseFrom:'',
						caseTo:'',
						},
						revenue_point: {
							target: 0,
							duration: 'MONTHLY',
						}
                    },
					comms_setting: {
						hub_am_comms_percentage: '',
						team_am_comms_percentage: '',
						resign_at:'',
					},
					is_external_staff:false
				},
			},
			double_message: null,
			user_statuses: [
				'DRAFT/PENDING',
				'ACTIVE',
				'INACTIVE',
				'PROBATION',
				'SUSPEND',
				'BANNED'
			],
			referralTypeOptions: [
				{
					'value': 'BUSINESS_PARTNER',
					'label': 'Business Partner',
				},
				{
					'value': 'MOBILE',
					'label': 'Mobile',
				},
				{
					'value': 'STAFF',
					'label': 'Staff',
				},
				{
					'value': 'CUSTOMER',
					'label': 'Customer',
				},
				{
					'value': 'ADVISOR_MOBILE',
					'label': 'Advisor Mobile',
				},
				{
					'value': 'ADVISOR_PERMANENT',
					'label': 'Advisor Permanent',
				}
			]
		}
	},
	watch: {
		
	},
	methods: {
		...mapActions(useAuthStore, ['fetchUserInfo']),
		...mapActions(useCommissionStore, ['getCommissionTeamList','getCommissionTeamGroupList','createApproval','createTeamGroup','createTeam','createTeamMember','updateUserExtend','getApprovalList']),
		removeRow(index) {
			this.kpiSettingArray.splice(index, 1); // Remove the row at the given index
		},
		addNewKPI() {
        // let revenueArray = [];
        // let caseArray = [];
		let kpiSettingArray  = [...this.kpiSettingArray];

        // Check if revenue target is greater than 0
        if (this.formParams.setting_json.kpi_setting.revenue.target > 0) {
            kpiSettingArray.push({
                "type": "REVENUE",
                "target": this.formParams.setting_json.kpi_setting.revenue.target,
                "duration": this.formParams.setting_json.kpi_setting.revenue.duration,
				"revenueFrom":  this.formParams.setting_json.kpi_setting.revenue.revenueFrom, // Add "from" date
                "revenueTo":  this.formParams.setting_json.kpi_setting.revenue.revenueTo // Add "to" date
            });
        }

        // Check if case target is greater than 0
        if (this.formParams.setting_json.kpi_setting.case.target > 0) {
            kpiSettingArray.push({
                "type": "CASE",
                "target": this.formParams.setting_json.kpi_setting.case.target,
                "duration": this.formParams.setting_json.kpi_setting.case.duration,
				"caseFrom":  this.formParams.setting_json.kpi_setting.case.caseFrom, // Add "from" date
                "caseTo":  this.formParams.setting_json.kpi_setting.case.caseTo // Add "to" date
            });
        }

		// Check if revenue point target is greater than 0
        if (this.formParams.setting_json.kpi_setting.revenue_point.target > 0) {
            kpiSettingArray.push({
                "type": "REVENUE_POINT",
                "target": this.formParams.setting_json.kpi_setting.revenue_point.target,
                "duration": this.formParams.setting_json.kpi_setting.revenue_point.duration,
            });
        }

        // Reset input fields
        this.formParams.setting_json.kpi_setting.revenue.target = '';
        this.formParams.setting_json.kpi_setting.revenue.duration = 'MONTHLY';
        this.formParams.setting_json.kpi_setting.case.target = '';
        this.formParams.setting_json.kpi_setting.case.duration = 'MONTHLY';
        this.formParams.setting_json.kpi_setting.revenue_point.target = '';
        this.formParams.setting_json.kpi_setting.revenue_point.duration = 'MONTHLY';
		this.formParams.setting_json.kpi_setting.revenue.revenueFrom = '';
        this.formParams.setting_json.kpi_setting.revenue.revenueTo = '';
		this.formParams.setting_json.kpi_setting.case.caseFrom = ''; 
        this.formParams.setting_json.kpi_setting.case.caseTo = ''; 

		this.kpiSettingArray = kpiSettingArray;
        // this.caseArray = caseArray;
    },
		switchTab(tabName) {
            // Close the current drawer
            if (this.show_drawer && tabName !== 'configurations') {
                this.show_drawer = false;
            }
            // Open the configurations drawer if the tabName is 'configurations'
            if (tabName === 'configurations') {
                this.show_configurations_drawer = true;
            }
        },
		showDrawer(userData=null) {
			if(!_gHlp.isEmpty(userData)){
				this.editData = userData;
				this.setData(userData)
				this.show_drawer = true;
			}
		},
		closeDrawer(refresh=false) {
			this.show_drawer = false;
			this.is_req_transfer_member = false,
			this.is_req_resign_member = false,
			this.formParams = {
				name: '',
				email: '',
				contact_number: '',
				role_id: '',
				mlv_upl_id: '',
				am_user_id: '',
				report_to_id: '',
				channel_id: '',
				platform_id: '',
				referral_by: '',
				created_at: '',
				pull_report_limit_json: {
					daily: 0,
					weekly: 0,
					monthly: 0
				},
				is_use_corp_subscription: true,
				is_have_recyle_lead: false,
				is_assistant_manager: null,
				status: '',
				referral_type: '',
				resign_at:'',
				hub_type:'',
				team_group_id:'',
				team_id:'',
				group_owner_id: '',
				team_owner_id: '',
				setting_json:
				{
					kpi_setting: {
						revenue: {
							target: '',
							duration: '',
						revenueFrom:'',
						revenueTo:'',
						},
						case: {
							target: '',
							duration: '',
						caseFrom:'',
						caseTo:'',
						},
						revenue_point: {
							target: 0,
							duration: 'MONTHLY',
						}
                    },
					comms_setting: {
						hub_am_comms_percentage: '',
						team_am_comms_percentage: '',
						resign_at:'',
					},
					is_external_staff:false
				},
			}
			// _gHlp.resetFormAttributes(this.formParams);
			this.$emit('close',refresh);
		},
		setData(newVal) {
				let currentRole = newVal.current_user_application;
				
				this.kpiSettingArray = [];

				if (
					currentRole &&
					currentRole.setting_json &&
					currentRole.setting_json.kpi_setting 
				) {
					const kpiSettings = currentRole.setting_json.kpi_setting;
					
					// Check if there's data for revenue
					if (kpiSettings.revenue && kpiSettings.revenue.length > 0) {
						// Loop through each record in the revenue array
						kpiSettings.revenue.forEach(revenueData => {
							this.kpiSettingArray.push({
								type: revenueData.type,
								target: revenueData.target,
								duration: revenueData.duration,
								revenueFrom: revenueData.revenueFrom,
								revenueTo: revenueData.revenueTo
							});
						});
					}

					// Check if there's data for case
					if (kpiSettings.case && kpiSettings.case.length > 0) {
						// Loop through each record in the case array
						kpiSettings.case.forEach(caseData => {
							this.kpiSettingArray.push({
								type: caseData.type,
								target: caseData.target,
								duration: caseData.duration,
								caseFrom: caseData.caseFrom,
								caseTo: caseData.caseTo
							});
						});
					}

					// Check if there's data for revenue point
					if (kpiSettings.revenue_point && kpiSettings.revenue_point.length > 0) {
						// Loop through each record in the case array
						kpiSettings.revenue_point.forEach(revenuePointData => {
							this.kpiSettingArray.push({
								type: revenuePointData.type,
								target: revenuePointData.target,
								duration: revenuePointData.duration,
							});
						});
					}
				}
				// this.formParams = newVal
				this.formParams.name = newVal.name
				this.formParams.email = newVal.email
				this.formParams.contact_number = newVal.contact_number
				this.formParams.ic_number = newVal.ic_number
				this.formParams.address = newVal.address
				this.formParams.bank_name = newVal.bank_name
				this.formParams.bank_account = newVal.bank_account
				this.formParams.role_id = currentRole && (currentRole.role.role_id > 0) ? parseInt(currentRole.role.role_id) : null
				this.formParams.mlv_upl_id = currentRole && (currentRole.mlv_upl_id > 0) ? parseInt(currentRole.mlv_upl_id) : null
				this.formParams.am_user_id = currentRole && (currentRole.am_user_id > 0) ? parseInt(currentRole.am_user_id) : null
				this.formParams.report_to_id = currentRole && (currentRole.report_to_id > 0) ? parseInt(currentRole.report_to_id) : null
				this.formParams.is_use_corp_subscription = currentRole && (currentRole.is_use_corp_subscription > 0) ? true : false
				this.formParams.is_have_recyle_lead = currentRole && (currentRole.is_have_recyle_lead > 0) ? true : false
				this.formParams.is_assistant_manager = currentRole ? currentRole.is_assistant_manager : null
				this.formParams.created_at = newVal.created_at

				this.formParams.channel_id = currentRole && (currentRole.channel.channel_id > 0) ?  parseInt(currentRole.channel.channel_id) : null
				this.formParams.platform_id = currentRole && (currentRole.platform.platform_id > 0) ?  parseInt(currentRole.platform.platform_id) : null
				this.formParams.pull_report_limit_json = currentRole && !_gHlp.isEmpty(currentRole.pull_report_limit_json) ? currentRole.pull_report_limit_json : {daily: 0,weekly: 0,monthly: 0},
				this.formParams.status = parseInt(newVal.status)
				this.formParams.setting_json = currentRole && !_gHlp.isEmpty(currentRole.setting_json) ? currentRole.setting_json : []

				//COMMISSION HUB SETTINGS
				this.formParams.hub = newVal.hub
				this.formParams.hub_type = newVal.hub_type
				this.formParams.referral_by = newVal.referral_by
				this.formParams.referral_type = newVal.user_tag?.tag_code
				this.formParams.resign_at = _gHlp.getValue(currentRole,'setting_json.comms_setting.resign_at',null)
				switch(newVal.hub_type)
				{
					case 'hub_manager':
						this.formParams.team_group_id = newVal.hub?.team_group_id ? parseInt(newVal.hub?.team_group_id): null
						this.formParams.group_owner_id = newVal.hub?.group_owner_id ? parseInt(newVal.hub?.group_owner_id): null
						this.formParams.team_owner_id = null
						break;
					case 'team_manager':
					case 'member':
						this.formParams.team_group_id = newVal.hub?.team_group_id ? parseInt(newVal.hub?.team_group_id): null
						this.formParams.team_id = newVal.hub?.team_id ? parseInt(newVal.hub?.team_id): null
						this.formParams.group_owner_id = newVal.hub?.team_group?.group_owner_id ? parseInt(newVal.hub?.team_group?.group_owner_id): null
						this.formParams.team_owner_id = newVal.hub?.team_owner_id ? parseInt(newVal.hub?.team_owner_id): null
						break;
					default:
						this.formParams.team_group_id = null
						this.formParams.team_id = null
						this.formParams.group_owner_id = null
						this.formParams.team_owner_id = null
				}
				if (
					currentRole &&
					currentRole.setting_json &&
					currentRole.setting_json.kpi_setting &&
					currentRole.setting_json.kpi_setting.revenue
				) {
					const revenueArray = currentRole.setting_json.kpi_setting.revenue;
					if (revenueArray && revenueArray.length > 0) {
						const revenueObject = revenueArray[0];

						if ("duration" in revenueObject && "target" in revenueObject) {
							const duration = revenueObject.duration;
							const target = revenueObject.target;
							if (!this.formParams.setting_json.kpi_setting) {
							this.$set(this.formParams.setting_json, 'kpi_setting', {});
							}
							this.$set(this.formParams.setting_json.kpi_setting, 'revenue', {
							target: target,
							duration: duration,
							});
						}
					}
				} else {
					if (!this.formParams.setting_json.kpi_setting) {
					this.$set(this.formParams.setting_json, 'kpi_setting', {});
					}
					this.$set(this.formParams.setting_json.kpi_setting, 'revenue', {
					target: 0,
					duration: 'MONTHLY',
					});
				}

				// Handle default values for caseArray
				if (
					currentRole &&
					currentRole.setting_json &&
					currentRole.setting_json.kpi_setting &&
					currentRole.setting_json.kpi_setting.case
				) {
					const caseArray = currentRole.setting_json.kpi_setting.case;
					if (caseArray && caseArray.length > 0) {
					const caseObject = caseArray[0];

					if ("duration" in caseObject && "target" in caseObject) {
						const duration = caseObject.duration;
						const target = caseObject.target;
						if (!this.formParams.setting_json.kpi_setting) {
						this.$set(this.formParams.setting_json, 'kpi_setting', {});
						}
						this.$set(this.formParams.setting_json.kpi_setting, 'case', {
						target: target,
						duration: duration,
						});
					}
					}
				} else {
					if (!this.formParams.setting_json.kpi_setting) {
					this.$set(this.formParams.setting_json, 'kpi_setting', {});
					}
					this.$set(this.formParams.setting_json.kpi_setting, 'case', {
					target: 0,
					duration: 'MONTHLY',
					});
				}

				// Handle default values for revenuePointArray
				if (
					currentRole &&
					currentRole.setting_json &&
					currentRole.setting_json.kpi_setting &&
					currentRole.setting_json.kpi_setting.revenue_point
				) {
					const revenuePointArray = currentRole.setting_json.kpi_setting.revenue_point;
					if (revenuePointArray && revenuePointArray.length > 0) {
					const revenuePointObject = revenuePointArray[0];

					if ("duration" in revenuePointObject && "target" in revenuePointObject) {
						const duration = revenuePointObject.duration;
						const target = revenuePointObject.target;
						if (!this.formParams.setting_json.kpi_setting) {
							this.$set(this.formParams.setting_json, 'kpi_setting', {});
						}
						this.$set(this.formParams.setting_json.kpi_setting, 'revenue_point', {
							target: target,
							duration: duration,
						});
					}
					}
				} else {
					if (!this.formParams.setting_json.kpi_setting) {
						this.$set(this.formParams.setting_json, 'kpi_setting', {});
					}
					this.$set(this.formParams.setting_json.kpi_setting, 'revenue_point', {
						target: 0,
						duration: 'MONTHLY',
					});
				}

				if(currentRole.is_assistant_manager != null)
				{
					this.$set(this.formParams.setting_json, 'comms_setting', currentRole.setting_json.comms_setting);
				}
				else
				{
					if (!this.formParams.setting_json.comms_setting) {
						this.$set(this.formParams.setting_json, 'comms_setting', {});
					}
					this.$set(this.formParams.setting_json.comms_setting, 'hub_am_comms_percentage', null);
					this.$set(this.formParams.setting_json.comms_setting, 'team_am_comms_percentage', null);
				}
				this.checkCommApproval()
		},
		// checkEmailUser() {
		// 	this.double_message = null;
		// 	if (!this.isEmpty(this.formParams.email)) {
		// 		axios.get(services.access_control + 'user?email=' + this.formParams.email, { headers: getHeader() })
		// 			.then(res => {
		// 				let d = res.data.data;
		// 				if (d.length > 0) {
		// 					const groupedData = _.groupBy(d, 'id');
		// 					const result = _.mapValues(groupedData, (group) => {
		// 						return group.map(item => item.user_role_applications.map(role => role.application_code));
		// 					});
		// 					const exis_app = _.uniq(_.flatMap(result));
		// 					const existing_app = (exis_app) ? exis_app.join(",") : '';
		// 					if (exis_app.indexOf(this.app_code) !== -1) {
		// 						this.double_message = " This email has been used";
		// 					} else {
		// 						this.double_message = " Please be note that this email has been associated with system on application code " + existing_app + ", the email and password will remain the same for both system login";
		// 					}
		// 				} else {
		// 					this.double_message = null;
		// 				}
		// 			})
		// 			.catch(e => {
		// 				this.errorFunction(e)
		// 			})
		// 	}
		// },
		// submitUpdate() {
		// 	let revenueArray = [];
        //     let caseArray = [];

		// 	// Check if revenue target is greater than 0
		// 	if (this.formParams.setting_json.kpi_setting.revenue.target > 0) {
		// 		revenueArray.push({
		// 			"type": "REVENUE",
		// 			"target": this.formParams.setting_json.kpi_setting.revenue.target,
		// 			"duration": this.formParams.setting_json.kpi_setting.revenue.duration,
		// 		});
		// 	}

		// 	// Check if case target is greater than 0
		// 	if (this.formParams.setting_json.kpi_setting.case.target > 0) {
		// 		caseArray.push({
		// 			"type": "CASE",
		// 			"target": this.formParams.setting_json.kpi_setting.case.target,
		// 			"duration": this.formParams.setting_json.kpi_setting.case.duration,
		// 		});
		// 	}
		// 	let data = {
		// 		"name": this.formParams.name,
		// 		"email": this.formParams.email,
		// 		"contact_number": this.formParams.contact_number,
		// 		"role_apps": [
		// 			{
		// 				"role_id": this.formParams.role_id,
		// 				"corporate_id": this.auth_user.account_info.corporate_id,
		// 				"mlv_upl_id": this.formParams.mlv_upl_id, // for parent hierarchy value from user_role_applications.id
		// 				"mlv_pos_que": null, //sequence hierarchy
		// 				"is_use_corp_subscription": this.formParams.is_use_corp_subscription ? 1 : 0,
		// 				"is_have_recyle_lead": this.formParams.is_have_recyle_lead ? 1 : 0,
		// 				"channel_id": this.formParams.channel_id,
		// 				"platform_id": this.formParams.platform_id,
		// 				"pull_report_limit_json": this.formParams.pull_report_limit_json,
		// 				"setting_json": {
        //             "kpi_setting": {
        //                 "revenue": revenueArray,
        //                 "case": caseArray,
        //             },
        //         },
        //     },
        // ],
		// 		"status": this.formParams.status, // active
		// 	}

		// 	axios.put(services.access_control + 'user/' + this.editData.id, data, { headers: getHeader() })
		// 		.then(res => {
		// 			_gNotif.notifySuccess('<b>User:</b> - Successfully Updated.')
		// 			this.closeDrawer();
		// 		})
		// 		.catch(e => {
		// 			_gNotif.errorFunction(e)
		// 		})
		// },
		getUpdateData(){
			let revenueArray = [];
            let caseArray = [];
            let revenuePointArray = [];

			// Check if there is data in the table
			if (this.kpiSettingArray.length > 0) {
				// Iterate over each row in the table data
				this.kpiSettingArray.forEach(item => {
					// Check the type of KPI and push it to the respective array
					if (item.type === 'REVENUE') {
						revenueArray.push({
							"type": "REVENUE",
							"target": item.target,
							"duration": item.duration,
							"revenueFrom": item.revenueFrom,
							"revenueTo": item.revenueTo,
						});
					} else if (item.type === 'CASE') {
						caseArray.push({
							"type": "CASE",
							"target": item.target,
							"duration": item.duration,
							"caseFrom": item.caseFrom,
							"caseTo": item.caseTo,
						});
					} else if (item.type === 'REVENUE_POINT') {
						revenuePointArray.push({
							"type": "REVENUE_POINT",
							"target": item.target,
							"duration": item.duration,
						});
					}
				});
			} else {
				// Use data from the input fields directly if the table is empty
				if (this.formParams.setting_json.kpi_setting.revenue.target > 0) {
					revenueArray.push({
						"type": "REVENUE",
						"target": this.formParams.setting_json.kpi_setting.revenue.target,
						"duration": this.formParams.setting_json.kpi_setting.revenue.duration,
						"revenueFrom": this.formParams.setting_json.kpi_setting.revenue.revenueFrom,
						"revenueTo": this.formParams.setting_json.kpi_setting.revenue.revenueTo,
					});
				}

				// Check if case target is greater than 0
				if (this.formParams.setting_json.kpi_setting.case.target > 0) {
					caseArray.push({
						"type": "CASE",
						"target": this.formParams.setting_json.kpi_setting.case.target,
						"duration": this.formParams.setting_json.kpi_setting.case.duration,
						"caseFrom": this.formParams.setting_json.kpi_setting.case.caseFrom,
						"caseTo": this.formParams.setting_json.kpi_setting.case.caseTo,
					});
				}

				// Check if revenue point target is greater than 0
				if (this.formParams.setting_json.kpi_setting.revenue_point.target > 0) {
					revenuePointArray.push({
						"type": "REVENUE_POINT",
						"target": this.formParams.setting_json.kpi_setting.revenue_point.target,
						"duration": this.formParams.setting_json.kpi_setting.revenue_point.duration,
					});
				}
			}

			var assistant_manager = null;
			if(this.formParams.is_assistant_manager != "NOT")
			{
				assistant_manager = this.formParams.is_assistant_manager
			}

			return {
				"name": this.formParams.name,
				"email": this.formParams.email,
				"contact_number": this.formParams.contact_number,
				"referral_by": this.formParams.referral_by,
				"ic_number": this.formParams.ic_number,
				"bank_name": this.formParams.bank_name,
				"bank_account": this.formParams.bank_account,
				"address": this.formParams.address,
				"role_apps": [
					{
						"role_id": this.formParams.role_id,
						"corporate_id": this.auth_user.account_info.corporate_id,
						"mlv_upl_id": this.formParams.mlv_upl_id, // for parent hierarchy value from user_role_applications.id
						"am_user_id": this.formParams.am_user_id,
						// "report_to_id": this.formParams.report_to_id, // for report to hierarchy value from user_role_applications.id
						"mlv_pos_que": null, //sequence hierarchy
						"is_use_corp_subscription": this.formParams.is_use_corp_subscription ? 1 : 0,
						"is_have_recyle_lead": this.formParams.is_have_recyle_lead ? 1 : 0,
						"is_assistant_manager": assistant_manager,
						"channel_id": this.formParams.channel_id,
						"platform_id": this.formParams.platform_id,
						"pull_report_limit_json": this.formParams.pull_report_limit_json,
						"setting_json": {
							"kpi_setting": {
								"revenue": revenueArray,
								"case": caseArray,
								"revenue_point": revenuePointArray,
							},
							"comms_setting": {
								"hub_am_comms_percentage": this.formParams.setting_json.comms_setting.hub_am_comms_percentage,
								"team_am_comms_percentage": this.formParams.setting_json.comms_setting.team_am_comms_percentage,
								"resign_at":this.formParams.setting_json.comms_setting.resign_at,
							},
							'is_external_staff': _gHlp.getValue(this.formParams.setting_json,'is_external_staff',false),
						},
					},
        ],
				"status": this.formParams.status, // active
			}
		},
		submitUpdate() {
			let data = this.getUpdateData()
			axios.put(services.access_control + 'user/' + this.editData.id, data, { headers: getHeader() })
				.then(async (res) => {
					await this.updaterefferalType()
					await this.submitReqUpdateHub()
					_gNotif.notifySuccess('<b>User:</b> - Successfully Updated.');
					this.closeDrawer(true);
				})
				.catch(e => {
					_gNotif.errorFunction(e);
				});

			axios.put(process.env.VUE_APP_KRAKEND_API_GATEWAY + '/srv-commission/' + 'payout/update-user-detail/' + this.editData.id, {name: data.name}, { headers: getHeader() })
				.then(res => {
					_gNotif.notifySuccess('<b>User:</b> - Successfully Updated in Payout.');
					// this.closeDrawer(true);
				})
				.catch(e => {
					// _gNotif.errorFunction(e);
				});
		},
		async updaterefferalType(){
			if(!_gHlp.isEmpty(this.formParams.referral_type))
			{
				const postData = {
					user_id: this.editData.id,
					tag_code: this.formParams.referral_type
				}
				await axios.post(services.access_control + 'user_tag', postData, { headers: getHeader() }).then(res => {}).catch(e => {_gNotif.errorFunction(e);});
			}
		},
		async submitReqUpdateHub(){
			if(_gAuth.isAppSas()){
				await this.submitReqUpdateHubSas()
				await this.submitReqResign()
				return;
			}

			var assistant_manager = null;
			if(this.formParams.is_assistant_manager != "NOT")
			{
				assistant_manager = this.formParams.is_assistant_manager
			}

			let old_group_owner_id = _gHlp.getValue(this.editData,'hub.group_owner_id',_gHlp.getValue(this.editData,'hub.team_group.group_owner_id'))
			let oldParams = {
				group_owner_id: old_group_owner_id ? parseInt(old_group_owner_id) : null,
				team_group_id: _gHlp.getValue(this.editData,'hub.team_owner_id') ? parseInt(_gHlp.getValue(this.editData,'hub.team_owner_id')) : null,
				user_id: this.editData.id,
				is_assistant_manager: _gHlp.getValue(this.editData,'current_user_application.is_assistant_manager')
			}
			let newParams = {
				group_owner_id: this.formParams.group_owner_id,
				team_owner_id: this.formParams.team_owner_id ? parseInt(this.formParams.team_owner_id) : this.formParams.mlv_upl_id,
				user_id: this.editData.id,
				is_assistant_manager: assistant_manager,
			}
			if(_.isEqual(oldParams, newParams)) return;

			await axios.post(services.commission + 'team-group/update-user', newParams, { headers: getHeader() })
			.then(res => {
			})
			.catch(e => {
				_gNotif.errorFunction(e);
			});
		},
		async submitReqUpdateHubSas(){
			let oldParams = {
				hub_type: _gHlp.getValue(this.editData,'hub.hub_type'),
				team_group_id: _gHlp.getValue(this.editData,'hub.team_group_id') ? parseInt(_gHlp.getValue(this.editData,'hub.team_group_id')) : null,
				team_id: _gHlp.getValue(this.editData,'hub.team_id') ? parseInt(_gHlp.getValue(this.editData,'hub.team_id')) : null
			}
			let newParams = {
				hub_type: this.formParams.hub_type,
				team_group_id: this.formParams.team_group_id ? parseInt(this.formParams.team_group_id) : null,
				team_id: this.formParams.team_id ? parseInt(this.formParams.team_id) : null
			}
			if(_.isEqual(oldParams, newParams)) return;
			//IF CHANGE TYPE
			switch(newParams.hub_type)
			{
				case 'member':{
					if(!_gHlp.isEmpty(oldParams.team_id) && !_gHlp.isEmpty(newParams.team_id) && (oldParams.team_id != newParams.team_id)){
						const dataBefore = {
							team_id:oldParams.team_id,
							team_name:'',
							transfer_to:'',
							transfer_name:''
						}
						const dataApprove = {
							team_id: oldParams.team_id,
							team_name:'',
							transfer_to: newParams.team_id,
							transfer_name:'',
						}
						
						let prevTeamName = _gHlp.getValue(this.teamList.find(item => item.team_id == dataBefore.team_id),'team_name');
						let newTeamName = _gHlp.getValue(this.teamList.find(item => item.team_id == dataApprove.transfer_to),'team_name');
						
						dataBefore.team_name = prevTeamName;
						dataApprove.team_name = prevTeamName;
						dataApprove.transfer_name = newTeamName;
						
						await this.createApproval({
							table_name: 'team_members',
							table_key: 'id',
							table_id: _gHlp.getValue(this.editData,'hub.id'),
							custom_key: 'team-groups_' + oldParams.team_group_id + '_teams_'+oldParams.team_id + '_team-members_'+_gHlp.getValue(this.editData,'hub.id'),
							message: 'Transfer the Agent '+this.formParams.name+' from '+prevTeamName+' to '+newTeamName+ ' as per '+_gAuth.activeUser('name','')+' request from '+_gAuth.appCode()+' on '+_gHlp.formatMomentDate(_gHlp.getCurrentDateTime(), 'D MMM, YYYY h:mm A'),
							data_before: dataBefore,
							data_reject: null,
							data_approve: dataApprove,
							apv_runcode: 'TRANSFER_TEAM_MEMBER',
							apv_category: 'Hub Data Changes',
							apv_step: 2,
							apv_seq: 0,
							apv_status: 'Pending',
						})
					}else if(_gHlp.isEmpty(oldParams.team_id) && !_gHlp.isEmpty(newParams.team_id)){
						await this.createTeamMember({
							team_id:newParams.team_id,
							user_id:this.editData.id,
							join_at: _gHlp.formatMomentDate(_gHlp.getCurrentDateTime(), 'YYYY-MM-DD'),
							status:'Active'
						})
					}
					break;
				}
				default:{
					return;
				}
			}
		},
		async submitReqResign(resignAt = null){
			let apv_runcode = 'USER_RESIGN';
			const dataBefore = {
				resign_at:_gHlp.getValue(this.editData,'resign_at')
			}
			const dataApprove = {
				resign_at:this.formParams.resign_at ? this.formParams.resign_at : resignAt
			}
			if(_.isEqual(dataBefore, dataApprove)) return;

			if(_gHlp.isEmpty(dataBefore.resign_at) && !_gHlp.isEmpty(dataApprove.resign_at)){
				let ura_id = _gHlp.getValue(this.editData,'current_user_application.id')
				swal.fire({
						target: document.getElementById('drawer_update_user'),
						title: 'Are you sure?',
						text: "You won't be able to revert this!",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes, request for resign!'
				}).then(async (result) => {
						if (result.isConfirmed) {
							dataApprove.user_update = this.getUpdateData()
							dataApprove.user_update.role_apps[0].setting_json.comms_setting.resign_at = dataApprove.resign_at
							await this.createApproval({
								table_name: 'user_extend',
								table_key: 'user_id',
								table_id: this.editData.id,
								custom_key: 'user-extend_' + this.editData.id + '_ura-id_'+ura_id,
								message: 'Resign request for user '+this.formParams.name+' as per '+_gAuth.activeUser('name','')+' request from '+_gAuth.appCode()+' on '+_gHlp.formatMomentDate(_gHlp.getCurrentDateTime(), 'D MMM, YYYY h:mm A'),
								data_before: dataBefore,
								data_reject: null,
								data_approve: dataApprove,
								apv_runcode: apv_runcode,
								apv_category: 'Hub Data Changes',
								apv_step: 2,
								apv_seq: 0,
								apv_status: 'Pending',
							})
							_gNotif.notifySuccess('<b>User:</b> - Successfully Updated.');
							this.closeDrawer(true);
						}
				})
			}
		},
		async checkCommApproval(){
			let team_group_id= _gHlp.getValue(this.editData,'hub.team_group_id') ? parseInt(_gHlp.getValue(this.editData,'hub.team_group_id')) : null
			let team_id =_gHlp.getValue(this.editData,'hub.team_id') ? parseInt(_gHlp.getValue(this.editData,'hub.team_id')) : null
			let hub_id =_gHlp.getValue(this.editData,'hub.id') ? parseInt(_gHlp.getValue(this.editData,'hub.id')) : null
			
			let transfer_key = 'team-groups_' + team_group_id + '_teams_'+team_id + '_team-members_'+hub_id
			let resign_key = 'user-extend_' + this.editData.id + '_ura-id_'+_gHlp.getValue(this.editData,'current_user_application.id')
			
			this.is_req_transfer_member = !_gHlp.isEmpty(await this.getApprovalList({custom_key:transfer_key, apv_status:['Pending','Progress']}))
			this.is_req_resign_member = !_gHlp.isEmpty(await this.getApprovalList({custom_key:resign_key, apv_status:['Pending','Progress']}))
		},
		goToSasCommission(){
			let tkn = localStorage.getItem('auth_token')
			let app_code = localStorage.getItem('app_code')

			if(_gHlp.isEmpty(tkn) || _gHlp.isEmpty(app_code)){
				_gNotif.notifyError('Please login, Your token has expired');
				return false;
			}
			let auth_token = JSON.parse(tkn);
			let data = JSON.stringify({
				access_token: auth_token.access_token,
				expires_in: _gAuth.getActiveRemain(),
				app_code: app_code
			});
			
			let encrypt = _gHlp.aesEncrypt(data);
			let url = sasv3CommissionDomain +'/hub?auth=' + encrypt;				
			_gHlp.openNewTab(url);
		}
	}
}
</script>